import { useEffect, useState } from "react";
import BikeDetails from "../../components/modals/BikeDetails";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/elements/LoadingSpinner";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { getAllDispatch, logisticDashboard, getRiderStats } from "../../redux/thunk";

export const Logistics = () => {
  const [showBikeDetails, setShowBikeDetails] = useState(false);
  const [riderDetails, setRiderDetails] = useState({});
  const navigate = useNavigate();
  const { allRiderInfo, dashboard, status, riderStats } = useAppSelector(
    (store) => store.logistics
  );
  const dispatch = useAppDispatch();

  const [dataLoaded, setDataLoaded] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [dispatchResult] = await Promise.all([
          dispatch(getAllDispatch()),
          dispatch(logisticDashboard()),
          dispatch(getRiderStats()),
        ]);

        // Debug the rider data
        if (getAllDispatch.fulfilled.match(dispatchResult)) {
          console.log("Rider data received:", dispatchResult.payload);
        }

        setDataLoaded(true);
      } catch (error) {
        console.error("Error loading logistics data:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  const handleViewMore = (plateNo: string, bikeModel: string) => {
    setShowBikeDetails((prev) => !prev);
    setRiderDetails({ plateNo, bikeModel });
  };

  // If data is still loading and we haven't successfully loaded data before, show a loading indicator
  if (status === "loading" && !dataLoaded) {
    return (
      <main className="flex items-center justify-center h-screen">
        <div className="text-center">
          <LoadingSpinner />
          <p className="mt-4 text-gray-600">Loading logistics data...</p>
        </div>
      </main>
    );
  }

  return (
    <main>
      <div className="flex justify-between items-center">
        <h2 className="font-bold text-lg">Logistics</h2>
        <button
          className="bg-secondary p-2 text-white rounded-md hover:bg-green-700 transition duration-300"
          onClick={() => navigate("add-rider")}
        >
          Add Rider
        </button>
      </div>
      <section className="flex mt-5 justify-evenly flex-wrap gap-3">
        <div
          className={`bg-white p-5 rounded-md border border-green-300 shadow-md w-60 ${
            status === "loading" && "animate-pulse "
          }`}
        >
          <h2 className="text-sm font-medium pb-4 text-gray-700 caption-bottom">
            Total Riders
          </h2>
          <p className="font-semibold text-3xl">
            {status === "loading" ? "0" : (dashboard as any)?.totalDispatchers || 0}
          </p>
        </div>
        <div
          className={`bg-white p-5 rounded-md border border-green-300 shadow-md w-60 ${
            status === "loading" && "animate-pulse "
          }`}
        >
          <h2 className="text-sm font-medium pb-4 text-gray-700 caption-bottom">
            Riders on move
          </h2>
          <p className="font-semibold text-3xl">
            {status === "loading" ? "0" : (dashboard as any)?.dispatchersOnMove || 0}
          </p>
        </div>
        <div
          className={`bg-white p-5 rounded-md border border-green-300 shadow-md w-60 ${
            status === "loading" && "animate-pulse "
          }`}
        >
          <h2 className="text-sm font-medium pb-4 text-gray-600 caption-bottom">
            Available riders
          </h2>
          <p className="font-semibold text-3xl">
            {status === "loading" ? "0" : (dashboard as any)?.availableDispatchers || 0}
          </p>
        </div>
        {riderStats && (
          <>
            <div
              className={`bg-white p-5 rounded-md border border-blue-300 shadow-md w-60 ${
                status === "loading" && "animate-pulse "
              }`}
            >
              <h2 className="text-sm font-medium pb-4 text-gray-700 caption-bottom">
                Orders Today
              </h2>
              <p className="font-semibold text-3xl">
                {status === "loading" ? "0" : riderStats.ordersToday}
              </p>
            </div>
            <div
              className={`bg-white p-5 rounded-md border border-yellow-300 shadow-md w-60 ${
                status === "loading" && "animate-pulse "
              }`}
            >
              <h2 className="text-sm font-medium pb-4 text-gray-700 caption-bottom">
                Revenue Today
              </h2>
              <p className="font-semibold text-3xl">
                ₦{status === "loading" ? "0" : riderStats.revenueToday?.toLocaleString() || 0}
              </p>
            </div>
            <div
              className={`bg-white p-5 rounded-md border border-red-300 shadow-md w-60 ${
                status === "loading" && "animate-pulse "
              }`}
            >
              <h2 className="text-sm font-medium pb-4 text-gray-700 caption-bottom">
                Pending Issues
              </h2>
              <p className="font-semibold text-3xl">
                {status === "loading" ? "0" : riderStats.pendingIssues}
              </p>
            </div>
          </>
        )}
      </section>
      <section className="my-5 overflow-x-scroll">
        <section className="md:w-full w-[700px]">
          <div className="flex justify-between items-center w-full bg-white rounded-lg p-3 mb-2 gap-2">
            <h1 className="font-semibold ">Delivery Riders</h1>
            {/* <button
              className="bg-secondary text-white p-2 rounded-lg md:text-sm text-xs hover:bg-green-800"
              type="button"
              onClick={() => navigate("busy-riders")}
            >
              Busy Riders
            </button>
            <button
              className="bg-secondary text-white p-2 rounded-lg md:text-sm text-xs hover:bg-green-800"
              type="button"
              onClick={() => navigate("assign-delivery")}
            >
              Assign Delivery
            </button> */}
            <button
              className="bg-secondary text-white p-2 rounded-lg md:text-sm text-xs hover:bg-green-800"
              type="button"
              onClick={() => navigate("all-deliveries")}
            >
              All deliveries
            </button>

            <button
              className="bg-secondary text-white p-2 rounded-lg md:text-sm text-xs hover:bg-green-800"
              type="button"
              onClick={() => navigate("disbutes")}
            >
              Disputes
            </button>
            <label className="md:text-sm text-xs" htmlFor="filter">
              Sort:
              <select name="filter" id="filter" className="border p-2 ml-4">
                <option value="all">All</option>
                <option value="online">Online</option>
              </select>
            </label>
          </div>
          {status === "loading" ? (
            <LoadingSpinner />
          ) : (
            <table className="w-full text-left">
              <thead>
                <tr className="bg-gray-50 font-bold h-12 md:text-base text-sm">
                  <th>SN</th>
                  <th>Image</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {allRiderInfo.length > 0 ? (
                  allRiderInfo
                    .slice()
                    .reverse()
                    .map((item: any, index: any) => (
                      <tr key={index} className="border-b-2 hover:bg-gray-200">
                        <td className="md:text-base text-sm">{index + 1}</td>
                        <td
                          className="cursor-pointer"
                          onClick={() =>
                            navigate("rider-activity", {
                              state: {
                                id: item._id,
                                email: item.email,
                                firstName: item.firstName,
                                lastName: item.lastName,
                                status: item.status,
                                phoneNo: item.phoneNumber,
                                image:
                                  item.image ||
                                  "https://jy0s2swu0k.ufs.sh/f/LKSiq2B5GRS8nqXTASCYrqb8EcQRiuAhmfJoHsDWN5U347eg",
                              },
                            })
                          }
                        >
                          <div className="w-12 h-12 mx-auto my-1">
                            <img
                              src={
                                item.image ||
                                "https://jy0s2swu0k.ufs.sh/f/LKSiq2B5GRS8nqXTASCYrqb8EcQRiuAhmfJoHsDWN5U347eg"
                              }
                              className="w-full h-full"
                              alt={item.firstName}
                              onError={(e) => {
                                const target = e.target as HTMLImageElement;
                                target.onerror = null;
                                target.src =
                                  "https://jy0s2swu0k.ufs.sh/f/LKSiq2B5GRS8nqXTASCYrqb8EcQRiuAhmfJoHsDWN5U347eg";
                              }}
                            />
                          </div>
                        </td>
                        <td
                          className="cursor-pointer md:text-base text-sm"
                          onClick={() =>
                            navigate("rider-activity", {
                              state: {
                                id: item._id,
                                email: item.email,
                                firstName: item.firstName,
                                lastName: item.lastName,
                                status: item.status,
                                phoneNo: item.phoneNumber,
                                image:
                                  item.image ||
                                  "https://jy0s2swu0k.ufs.sh/f/LKSiq2B5GRS8nqXTASCYrqb8EcQRiuAhmfJoHsDWN5U347eg",
                              },
                            })
                          }
                        >
                          {item.lastName + " " + item.firstName}
                        </td>
                        <td
                          className="cursor-pointer md:text-base text-sm"
                          onClick={() =>
                            navigate("rider-activity", {
                              state: {
                                id: item._id,
                                email: item.email,
                                firstName: item.firstName,
                                lastName: item.lastName,
                                status: item.status,
                                phoneNo: item.phoneNumber,
                                image:
                                  item.image ||
                                  "https://jy0s2swu0k.ufs.sh/f/LKSiq2B5GRS8nqXTASCYrqb8EcQRiuAhmfJoHsDWN5U347eg",
                              },
                            })
                          }
                        >
                          {item.email}
                        </td>
                        <td>
                          <button
                            type="button"
                            onClick={() =>
                              handleViewMore(
                                item.vehiclePlate,
                                item.bikeModel_Color
                              )
                            }
                            className="p-2 md:text-sm text-xs bg-secondary rounded-md text-white"
                          >
                            Bike Info
                          </button>
                        </td>
                      </tr>
                    ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      className="p-5 bg-white text-center text-secondary"
                    >
                      No Riders!
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          )}
        </section>
      </section>
      {showBikeDetails && (
        <BikeDetails
          setShowBikeDetails={setShowBikeDetails}
          riderDetails={riderDetails}
        />
      )}
    </main>
  );
};
